import request from '@/utils/request'

export default {
    getReportsCategories: async({ commit, dispatch }, fetchAll) => {
        commit('SET_LOAD', true)

        const url = fetchAll ? '/category' : '/category/role'

        await request({ method: 'get', url })
            .then(res => {
                if (res.data) {
                    const mutation = fetchAll ? 'SET_CATEGORIES_LIST' : 'SET_ROLE_CATEGORIES'

                    commit(mutation, res.data)
                }
            }).finally(() => commit('SET_LOAD', false))
    },

    createReportCategory: async({ commit, dispatch }, data) => {
        await request({
            method: 'post',
            url: '/category',
            data
        }).then(res => {
            if (res.data) {
                commit('CREATE_REPORT_CATEGORY', res.data)
                dispatch('addMessage', {
                    message: 'category.created',
                    type: 'success',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message
                }, { root: true })
            }
        })
    },

    updateReportCategory: async({ commit, dispatch }, data) => {
        await request({
            method: 'put',
            url: `/category/${data.id}`,
            data
        }).then(res => {
            if (res.data) {
                commit('UPDATE_REPORT_CATEGORY', res.data)
                dispatch('addMessage', {
                    message: 'category.updated',
                    type: 'success',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: true
                }, { root: true })
            }
        })
    },

    removeReportCategory: async({ commit, dispatch }, id) => {
        await request({
            method: 'delete',
            url: `/category/${id}`
        }).then(res => {
            if (res.status === 204) {
                commit('REMOVE_REPORT_CATEGORY', id)
                dispatch('addMessage', {
                    message: 'category.removed',
                    type: 'success',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message,
                    locale: true
                }, { root: true })
            }
        })
    },

    getReportsList: async({ commit }) => {
        await request({
            method: 'get',
            url: '/sql-reports/all'
        }).then(res => {
            if (res.data) {
                commit('SET_REPORTS_LIST', res.data)
            }
        })
    },

    getReports: async({ commit, dispatch }, params) => {
        commit('SET_LOAD', true)

        await request({
            method: 'get',
            url: '/sql-reports',
            params
        }).then(res => {
            if (res.data && res.data.rows) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })

                commit('SET_REPORTS', res.data.rows)
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message
                }, { root: true })
            }
        }).finally(() => commit('SET_LOAD', false))
    },

    createReport: async({ commit, dispatch }, data) => {
        return request({
            method: 'post',
            url: '/sql-reports',
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    message: 'report.created',
                    type: 'success',
                    locale: true
                }, { root: true })
            }

            return res
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message
                }, { root: true })
            }
        })
    },

    updateReport: async({ commit, dispatch }, data) => {
        return request({
            method: 'put',
            url: `/sql-reports/${data.id}`,
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    message: 'report.updated',
                    type: 'success',
                    locale: true
                }, { root: true })
            }

            return res
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message,
                locale: true
            }, { root: true })

            return error
        })
    },

    removeReport: async({ commit, dispatch }, id) => {
        await request({
            method: 'delete',
            url: `/sql-reports/${id}`
        }).then(res => {
            if (res.status === 204) {
                dispatch('addMessage', {
                    message: 'report.removed',
                    type: 'success',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.data.message,
                locale: true
            }, { root: true })
        })
    }
}
